import React from "react";

import { useRouter } from "next/router";
import Slider from "react-slick";

import trustedByComponentStyles from "../../HomeComponent/TrustedByComponent/TrustedByComponent.module.css";
import styles from "./CitiesWePerformComponent.module.css";
const empty_image = "/assets/images/empty_image_placeholder.jpg";

export default function CitiesWePerformComponent(props) {
  const { cities } = props;
  const router = useRouter();

  const settings = {
    dots: false,
    speed: 300,
    className: styles.city_slider,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: cities.length > 5, // Set infinite to false if less than 5 items
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div>
      {cities?.length ? <>
        <h3 className={styles.citiesweperform_heading}>Venues we perform</h3>
        <ul className={trustedByComponentStyles.trustedby_list}>
          <Slider {...settings}>
            {Array.isArray(cities) &&
              cities.length > 0 &&
              cities.map((item, index) => (
                <div className={styles.citiesWePerform_list}  key={item._id ?? index}>
                  <li>
                    <div className={styles.citiesWePerform_image_wrapper}>
                      <img
                        src={
                          item.thumbnail !== ""
                            ? process.env.IMAGE_LINK + item.thumbnail
                            : process.env.IMAGE_LINK + empty_image
                        }
                        alt={`${item.name}`}
                        style={{ borderRadius: "50%", cursor: "pointer" }}
                        onClick={() => router.push(`/cities/${item.slug}`)}
                        width={222}
                        height={222}
                      />
                    </div>
                    <h4 className={styles.citiesWePerform_itemName}>
                      {item.name}
                    </h4>
                  </li>
                </div>
              ))}
          </Slider>
        </ul>
      </> : ""}
    </div>
  );
}
